import { makeObservable, action } from 'mobx'

class HiddenSettings {
  isMedicalRedirectEnabled = false
  isMswEnabled = false
  #workerInstance = null

  constructor() {
    makeObservable(this, {
      isMedicalRedirectEnabled: true,
      isMswEnabled: true,
      setUseMedicalVisit: action,
      setMswEnabled: action,
    })
  }

  setUseMedicalVisit(boolFlag) {
    this.isMedicalRedirectEnabled = boolFlag
  }

  async #getWorker() {
    if (!this.#workerInstance) {
      try {
        const { worker } = await import('../../testing/mocks/msw/browser')
        this.#workerInstance = worker
      } catch (error) {
        console.error('Failed to import MSW worker:', error)
        return null
      }
    }
    return this.#workerInstance
  }

  async setMswEnabled(boolFlag) {
    if (process.env.NODE_ENV !== 'development') {
      return
    }

    this.isMswEnabled = boolFlag

    try {
      const worker = await this.#getWorker()
      if (!worker) return

      if (boolFlag) {
        await worker.start()
        console.log('MSW worker started successfully')
      } else {
        await worker.stop()
        console.log('MSW worker stopped successfully')
      }
    } catch (error) {
      console.error(`Failed to ${boolFlag ? 'start' : 'stop'} MSW worker:`, error)
      // Revert the state if the operation failed
      this.isMswEnabled = !boolFlag
    }
  }
}

export default new HiddenSettings()
